import * as Sentry from '@sentry/browser'

let disabled = false
const isOAuthUrl = value => {
    if (!value) return false
    try {
        // history@4 decodes paths before matching the consent route.
        const pathname = decodeURI(new URL(value, window.location.origin).pathname)
        return /^\/(?:(?:en|bg|ru)\/)?(?:api\/)?oauth(?:\/|$)/i.test(pathname)
    } catch { return true }
}

export const telemetryAllowed = (...urls) => {
    if (typeof window === 'undefined') return false
    // Keep telemetry off for the rest of this document: navigation breadcrumbs
    // and the referrer can retain consent parameters after leaving the page.
    disabled ||= [window.location.href, document.referrer, ...urls].some(isOAuthUrl)
    if (disabled && process.env.REACT_APP_GA4_TRACKING_ID) {
        window[`ga-disable-${process.env.REACT_APP_GA4_TRACKING_ID}`] = true
    }
    return !disabled
}

export const startErrorReporting = () => {
    if (!telemetryAllowed()) return
    Sentry.init({
        dsn: 'https://d459a575e20c46fd87a2a60079399299@sentry.io/1238541',
        beforeSend: event => telemetryAllowed(event.request?.url) ? event : null,
        beforeBreadcrumb: breadcrumb => telemetryAllowed(breadcrumb.data?.from, breadcrumb.data?.to, breadcrumb.data?.url) ? breadcrumb : null,
    })
}
